module.exports = __webpack_public_path__ + "static/media/ICON_chevronRight_Dark.bf922f0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/ICON_chevronRight_Dark.svg
// module id = 57
// module chunks = 0